export const PRODUCT_LINE_GOALS_PERSIST = 'PRODUCT_LINE_GOALS_PERSIST'
export const PRODUCT_LINE_GOALS_PERSIST_SUCCESS = 'PRODUCT_LINE_GOALS_PERSIST_SUCCESS'
export const PRODUCT_LINE_GOALS_PERSIST_FAILURE = 'PRODUCT_LINE_GOALS_PERSIST_FAILURE'
